import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useContext, useEffect } from "react";
import NavContext from "./Context/NavContext";
import Home from "./components/Home";
import GlobalStyle from "./components/Style-components/GlobalStyle";
import ListOfBlogs from "./components/blogs/ListOfBlogs";
import Navbar from "./components/navbar/Navbar";
import Social from "./components/socials/Social";
import Footer from "./components/Footer/Footer";

function App() {
  const { click, winWidth } = useContext(NavContext);

  let boolean = click && winWidth < 769;

  useEffect(() => {
    boolean
      ? (document.body.style.padding = "0")
      : (document.body.style.padding = "1vmax 5vw 2vw 10vw");
  }, [boolean]);

  return (
    <>
      <GlobalStyle />
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blogs" element={<ListOfBlogs />} />
        </Routes>
        <Social />
        <Footer />
      </Router>
    </>
  );
}

export default App;
